import React, {Component} from 'react';
import lang from '../../../constants/Languages.js';
import propTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

//import components

import arrowDark from '../../../assets/icons/arrow-circle-full.svg';
import arrowLight from '../../../assets/icons/arrow-full-light.svg';

class ItemYearbookListItemNumber extends Component {
    render() {
        const {clang, dedication, link, label, description, id, book, cardId} = this.props;
        const isOpened = dedication || description;
        
        return (
            <li>
                <div className="card__yearbook__number-list-item">
                    <Link className={`card__yearbook__number ${cardId === id ? 'active' : ''}`} to={link} dangerouslySetInnerHTML={{__html: label}}></Link>
                    {cardId !== id &&
                        <Link to={`/item/journal-number/${id}`} className={`card__yearbook__number-details`} title={lang[clang].item.cards.show_yearbook_details}>
                            {lang[clang].item.cards.show_yearbook_details}
                            <img src={arrowDark} className="card__yearbook__number-arrow--dark" alt="" />
                            <img src={arrowLight} className="card__yearbook__number-arrow--light" alt="" />
                        </Link>}
                </div>
                {isOpened &&
                    <div className="card__yearbook__number-desc">
                        {dedication &&
                            <div className="card__yearbook__number-subsection">
                                <label className="card__yearbook__number-subsection-label">{lang[clang].item.cards.dedication}:</label>
                                <div className="card__yearbook__number-subsection-content" dangerouslySetInnerHTML={{__html: dedication}}>
                                </div>
                            </div>}
                        {description &&
                            <div className="card__yearbook__number-subsection">
                              <label className="card__yearbook__number-subsection-label">{lang[clang].item.cards.description}:</label>
                              <div className="card__yearbook__number-subsection-content" dangerouslySetInnerHTML={{__html: description}}>
                              </div>
                            </div>}
                        {book &&
                            <div className="card__yearbook__number-subsection">
                                <div className="card__yearbook__number-subsection-content--book">
                                    <span>{lang[clang].item.cards.is_developed}</span>
                                    <Link className="card__yearbook__number-subsection__book-link" to={`/item/${book.entityType}/${book.id}`}>{lang[clang].item.cards.as_book}</Link>.
                                </div>
                            </div>}
                    </div>}
            </li>
        );
    };
};

ItemYearbookListItemNumber.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemYearbookListItemNumber);



// WEBPACK FOOTER //
// ./src/components/items/cards/ItemYearbookListItemNumber.js